import { useState } from "react"

import { Flex, Tooltip, Typography } from "antd"
import cls from "classname"

import InfoTooltip from "../../../../../Components/InfoTooltip/InfoTooltip"
import Icon from "../../../../../Icon"
import CurrentMonthSlot from "../CurrentMonthSlot/CurrentMonthSlot"
import EcpTierControl from "../EcpTierControl/EcpTierControl"
import { PROGRAM_STATUS_LABEL, STATUS_CONDITIONS_TOGGLE } from "../monitoringCopy"
import StatusConditionsPanel from "../StatusConditionsPanel/StatusConditionsPanel"

import "./MonitoringBlockHeader.less"

const { Text } = Typography

const statusToVariantMap = {
  pending: "pending",
  compliant: "success",
  warning: "warning",
  under_monitoring: "error",
  no_status: "neutral"
}

const MonitoringBlockHeader = ({
  blockId,
  program,
  status,
  currentMonth,
  thresholds,
  region,
  tier,
  lastClosedMonth
}) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  const panelId = `${blockId}-status-conditions`
  const variant = statusToVariantMap[status?.status] || "neutral"

  return (
    <div className="monitoring-block-header">
      <div className="monitoring-block-header__slots">
        <div className="monitoring-block-header__slot">
          <Text type="secondary" className="monitoring-block-header__label">
            {PROGRAM_STATUS_LABEL}
          </Text>
          <Flex align="center" gap={8}>
            <span className={cls("monitoring-block-header__dot", variant)} />
            {/* The program status label is the only text on the page rendered in a semantic
                colour (§0 R2). */}
            <Text className={cls("status-text", variant)}>
              {status?.status_label || "Unknown status"}
            </Text>
            {/* The tooltip explains the account's current status; the panel explains all statuses.
                The two are not merged (§2 R8). */}
            <InfoTooltip title={status?.tooltip || "No information available"} />
            {/* Label and chevron are one button, not a labelled pair: a single tab stop, a single
                aria-expanded, and the hover state covers both halves at once. */}
            <Tooltip
              title={isPanelOpen ? STATUS_CONDITIONS_TOGGLE.hide : STATUS_CONDITIONS_TOGGLE.show}
            >
              <button
                type="button"
                className={cls("monitoring-block-header__toggle", { open: isPanelOpen })}
                aria-expanded={isPanelOpen}
                aria-controls={panelId}
                onClick={() => setIsPanelOpen((open) => !open)}
              >
                {STATUS_CONDITIONS_TOGGLE.label}
                <Icon type="chevron_down_small" />
              </button>
            </Tooltip>
            <EcpTierControl tier={tier} lastClosedMonth={lastClosedMonth} />
          </Flex>
        </div>

        <div className="monitoring-block-header__divider" />

        <CurrentMonthSlot
          program={program}
          currentMonth={currentMonth}
          thresholds={thresholds}
          region={region}
        />
      </div>

      <StatusConditionsPanel id={panelId} isOpen={isPanelOpen} />
    </div>
  )
}

export default MonitoringBlockHeader
